import { useEffect, useRef } from 'react';
import { useAppDispatch } from '@/shared/hooks/store';
import { selectIsAuthorized } from '@/store/slices/auth/selectors';
import { useAppSelector } from '@/shared/hooks/store';
import AlertIcon from '@/assets/icons/acessibe.svg';
import IntercomIcon from '@/assets/icons/intercom.svg';
import { setAccessibilityTop } from '@/store/slices/floating-icons-state';
import { selectIsPopoverAutocompleteOpen } from '@/store/slices/onboarding/selectors';

const IntercomAccessibe = () => {
    const isPopoverAutocompleteOpen = useAppSelector(selectIsPopoverAutocompleteOpen);
    const isAuthorized = useAppSelector(selectIsAuthorized);
    const intercomLauncherRef = useRef<HTMLAnchorElement>(null);
    const containerRef = useRef<HTMLDivElement>(null);
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (!containerRef.current) return;

        const updateOffset = () => {
            if (containerRef.current) {
                const rect = containerRef.current.getBoundingClientRect();
                const offsetFromBottomToTop = window.innerHeight - rect.top;
                dispatch(setAccessibilityTop(offsetFromBottomToTop));
            }
        };

        updateOffset();

        const observer = new MutationObserver(updateOffset);
        observer.observe(containerRef.current, { attributes: true, childList: true, subtree: true });

        return () => observer.disconnect();
    }, [dispatch]);

    return (
        <div data-testid="intercom-accessibe-container" ref={containerRef} className={`${isAuthorized && !isPopoverAutocompleteOpen ? 'bottom-[80px] lg:bottom-4' : 'bottom-4'} fixed right-4 z-[100] fixed`} >
            <div className='flex flex-col lg:flex-row gap-4'>
                <div>
                    <a data-testid="accessibe-link" className="bg-blue-300 p-2.5 sm:p-3 rounded-full w-[40px] h-[40px]  sm:w-[50px] sm:h-[50px] flex items-center justify-center" href="#" data-acsb-custom-trigger="true">
                        <img className="h-[30px] sm:h-[35px]" src={AlertIcon} alt="info icon" />
                    </a>
                </div>
                {isAuthorized && <div>
                    <a ref={intercomLauncherRef} data-testid="intercom-link" className="intercom-launcher bg-[#00B299] p-2.5 sm:p-3 rounded-full w-[40px] h-[40px]  sm:w-[50px] sm:h-[50px] flex items-center justify-center" href="#">
                        <img className="h-[30px] sm:h-[35px]" src={IntercomIcon} alt="info icon" />
                    </a>
                </div>}
            </div>
        </div>
    )
}


export default IntercomAccessibe;